import { useEffect, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { useSearchParams } from 'react-router-dom';


export default function CheckoutPage() {
  const [ready, setReady] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const tier = searchParams.get('tier')

  useEffect(() => {
    (async () => {
      const stripe = await loadStripe('pk_test_51RgAHQL2l0UBuO0j9h60OvjVIs9ybBWlfooKi5dKtNX7gufmJU3krzqIUJSc3Z0k7v1MkPwYbDWWQC5vWOkXHNDo00CkrIFdak');
      if (!stripe) {
        console.error('Stripe failed to load');
        return;
      }

      // Ask backend for client_secret
      const fetchClientSecret = async () => {
        const res = await fetch(`http://localhost:5000/api/checkout`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({tier}),
        });
        
        const { clientSecret } = await res.json();
        return clientSecret;
      };

      // Initialize & mount Embedded Checkout
      const checkout = await stripe.initEmbeddedCheckout({
        fetchClientSecret,
      });
      checkout.mount('#checkout');
      setReady(true);
    })();
  }, []);

  return (
    <div className="max-w-2xl mx-auto py-8">
      <h1 className="text-2xl font-semibold mb-4">Subscribe</h1>
      <div id="checkout" className="border rounded p-4" />
      {!ready && <p>Loading subscription form…</p>}
    </div>
  );
}
